import { useSelector } from 'react-redux'
import { ApplicationState } from '@/state/root.models'
import useForm from '@/hooks/form/use-form.hook'

import { FormStatusType } from '@/enums/form-status.enum'
import { dependenciesSchema } from '../components/schema'
import { dependenciesValidator } from '../components/validator'

const useDependencies = () => {
  const { currentBonus, bonusFormMode, bonusesByBundle } = useSelector(
    ({ bonusEngine }: ApplicationState) => bonusEngine,
  )

  const { state, handleOnChange, disable, setFormValues, setDisable } = useForm(
    dependenciesSchema,
    dependenciesValidator,
    () => {},
  )

  const convertDependentBonusIds = () =>
    currentBonus.bonusBundle
      ? currentBonus.bonusBundle.map((id) => {
          const bonusOffer = bonusesByBundle.find((bonus) => bonus._id === id)
          return {
            name: bonusOffer?.name,
            _id: bonusOffer?._id,
          }
        })
      : []

  const setCurrentBonusDependencies = () => {
    setFormValues({
      bonusBundle: {
        value: convertDependentBonusIds(),
        error: '',
      },
    })
    bonusFormMode === FormStatusType.CREATE
      ? setDisable(true)
      : setDisable(false)

    setDisable(false)
  }

  const handleOnChangeBonusBundle = (name: string, data: any) => {
    handleOnChange(name, data)
  }

  return {
    dependencies: {
      state,
      handleOnChange,
      disable,
      setFormValues,
      setDisable,
    },
    handleOnChangeBonusBundle,
    setCurrentBonusDependencies,
  }
}

export default useDependencies
